/* eslint-disable max-len */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isEmptyObject } from '../../utilities/helperUtilities';
import type { RootState } from '../store';
import {
  fetchAllAnnouncements,
  fetchAnnouncementById,
  fetchAnnouncementsByDocumentType,
} from '../thunks/announcementsThunks';
import { AnnouncementPanelModel } from 'src/types/AnnouncementPanelModel';
import { AnnouncementDataModel } from 'src/types/propTypes/AnnouncementDataModel';

interface AnnouncementsState {
  items: AnnouncementDataModel[];
  item: AnnouncementPanelModel | undefined;
}

export const defaultItemsState: AnnouncementDataModel[] = [];


export const initialState: AnnouncementsState = {
  items: defaultItemsState,
  item: undefined,
};

export const announcementsSlice = createSlice({
  name: 'announcements',
  initialState,
  reducers: {
    clearItems: (state) => {
      state.items = defaultItemsState;
    },
    saveItems: (state, action: PayloadAction<AnnouncementDataModel[]>) => {
      state.items = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAnnouncementsByDocumentType.pending, (state) => {
      state.items = defaultItemsState;
    });
    builder.addCase(fetchAnnouncementsByDocumentType.fulfilled, (state, action) => {
      state.items = action.payload ?? defaultItemsState;
    });

    // fetchAllAnnouncements
    builder.addCase(fetchAllAnnouncements.pending, (state) => {
      state.items = defaultItemsState;
    });
    builder.addCase(fetchAllAnnouncements.fulfilled, (state, action) => {
      if (!isEmptyObject(action.payload)) {
        state.items = action.payload;
      }
    });
    builder.addCase(fetchAllAnnouncements.rejected, (state, action) => {
      if (!action.meta.aborted) {
      }
    });

    // fetchAnnouncementById
    // builder.addCase(fetchAnnouncementById.pending, (state) => {
    // });
    builder.addCase(fetchAnnouncementById.fulfilled, (state, action) => {
      if (!isEmptyObject(action.payload)) {
      }
    });
    builder.addCase(fetchAnnouncementById.rejected, (state, action) => {
      if (!action.meta.aborted) {
      }
    });
  },
});

//export reducers
export const {
  clearItems,
  saveItems,
} = announcementsSlice.actions;

// allItems
export const selectAnnouncements = (
  state: RootState
): AnnouncementDataModel[] => state.announcements.items;

// announcementItem
export const selectAnnouncementItem = (
  state: RootState
): AnnouncementPanelModel | undefined => state.announcements.item;

export default announcementsSlice.reducer;
